<div class="mealtimesholder">
    <div class="mealtimelabel">Meal Times</div>
    <div class="mealrows" *ngFor="let mealtime of MealtimesInfo; let i=index;">
        <div class="mealrow row">
            <div class="col-5 mealname">
                {{mealtime.aiiActivityName}}:
            </div>
            <div class="col-7 mealtime">
                {{mealtime.aiibegtime | timepipe}}-{{mealtime.aiiendtime | timepipe}}
            </div>
        </div>
    </div>
    <div class="mealbutton ">
        <button type="button" class="btn  btn-light" [routerLink]="['/meal']">More</button>
    </div>
</div>